"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require('./../scss/sites/lagunitas/lagunitas.scss');
const index_1 = require("./index");
const lagunitas_1 = require("./Sites/lagunitas");
// Initialize scripts that are used in all websites
(0, index_1.Init)();
// Initialize TastingDays2021 specific scripts
(0, lagunitas_1.InitLagunitas)();
// Import styles and scripts included in coreweb packages
(0, index_1.ImportCoreweb)();
// Initialize and mount react components
(0, index_1.InitReact)();
